export default __webpack_public_path__ + "static/lutein-howto-feature1-9341c34e08b8017dd364aeb8909e5535.jpg";